import { Db } from 'mongodb'
import { schema, types } from 'papr'
import { VISIBILITY } from '../shared'
import { PROJECT_DELETION_TTL } from '../shared/constants'

const collectionName = 'docsCustomPages'

export const docsCustomPageSchema = schema(
	{
		projectId: types.objectId({ required: true }),
		visibility: types.enum(VISIBILITY, { required: true }),
		slug: types.string({ required: true }),
		ogMetaData: types.object(
			{
				image: types.string(),
			},
			{
				required: true,
			},
		),
		title: types.string({ required: true }),
		content: types.string({ required: true }),
		seo: types.object(
			{
				title: types.string({ required: true }),
				description: types.string(),
				shouldNotIndex: types.boolean(),
			},
			{ required: true },
		),
		/**
		 * The time when the custom page was soft deleted.
		 * User can request to restore the custom page for a small duration. After that, the custom page will be permanently deleted.
		 */
		deletedAt: types.date(),
	},
	{
		timestamps: true,
	},
)

export const createDocsCustomPagesIndex = async (db: Db) => {
	await db.createIndex(
		collectionName,
		{
			deletedAt: 1,
		},
		{
			expireAfterSeconds: PROJECT_DELETION_TTL,
		},
	)
}

export type DocsCustomPageDocument = (typeof docsCustomPageSchema)[0]
export type DocsCustomPageSchemaOptions = (typeof docsCustomPageSchema)[1]
